import React from 'react';
import ReactLoading from 'react-loading';
import './Carregando.css';

export default props => {
  const { type = 'spin', height = 80, width = 80, color = '#FFF' } = props;

  return (
    <div className="Carregando">
      <ReactLoading type={type} height={height} width={width} color={color} />
    </div>
  );
};
